
import { ORIGIN } from './nexsys-monitor.constant';
import { DATEFORMAT, CvDateFormatter } from '@cv-invision/cv.component-library.ux';

/**
 * Defines the columns
 * And any action against the columns
 */
export class CallbackLogsColumnsModel {
	private _columns: Array<any>;

	constructor(source: string, dateService: CvDateFormatter) {
		let field   = 'valutrustOrderId';
		let orderId = 'orderId';
		let statusField = 'status';
		let statusCellRender = null;

		switch (source) {
			case ORIGIN.Nexsys:
				field = 'nexsysOrderId';
				break;
			case ORIGIN.OrderExternal:
				orderId = 'classOrderId';
				break;
			case ORIGIN.FNC:
				field = 'fncOrderId';
				break;
			case ORIGIN.EVO:
				field            = 'evoOrderId';
				statusField      = 'httpCodeResponse';
				statusCellRender = 'customActionNexsysHTTPStatusCodeComponent';
				break;
		}

		this._columns = [
			{
				headerName: 'Transaction',
				field: 'transactionId',
				width: 130
			},
			{
				headerName: `${source} Order ID`,
				field: field,
				width: 90,
				hide:source === ORIGIN.OrderExternal,
			},
			{
				headerName: 'Class Order ID',
				field: orderId,
				width: 90
			},
			{
				headerName: 'Event Name',
				field: 'eventName',
				width: 90
			},
			{
				headerName: 'Status',
				field: statusField,
				width: 100,
				cellRenderer: statusCellRender,
			},
			{
				headerName: 'Duration',
				field: 'duration',
				width: 60,
				cellRenderer: 'suffixCellRenderer',
				cellRendererParams: { suffix: 'ms', fieldName: 'duration' }
			},
			{
				headerName: 'Received',
				field: 'created',
				width: 140
			},
			{
				headerName: 'Received (Local)',
				field: 'created',
				width: 160,
				valueFormatter: params =>  dateService.format(DATEFORMAT.EMPTY,params.data.created)
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}


export class CallbackFNCLogsColumnsModel {
	private _columns: Array<any>;
	constructor(source: string, dateService: CvDateFormatter) {

		let orderId = 'orderId';
		let field = 'fncOrderId';

		this._columns = [
			{
				headerName: 'Transaction',
				field: 'transactionId',
				width: 130
			},
			{
				headerName: `${source} Order ID`,
				field: field,
				width: 90,
				hide:source === ORIGIN.OrderExternal,
			},
			{
				headerName: 'Class Order ID',
				field: orderId,
				width: 90
			},
			{
				headerName: 'Duration',
				field: 'duration',
				width: 60,
				cellRenderer: 'suffixCellRenderer',
				cellRendererParams: { suffix: 'ms', fieldName: 'duration' }
			},
			{
				headerName: 'Received',
				field: 'created',
				width: 140
			},
			{
				headerName: 'Received (Local)',
				field: 'created',
				width: 160,
				valueFormatter: params =>  dateService.format(DATEFORMAT.EMPTY,params.data.created)
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
